module.exports = __webpack_public_path__ + "static/media/ig-partners.9cd61833.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/ig-partners.png
// module id = 118
// module chunks = 0